<section class="home-para-mi" aria-labelledby="home-para-mi-title">
  <div class="home-para-mi__inner">
    <h2 id="home-para-mi-title" class="home-para-mi__title" [innerHTML]="titleSafe"></h2>

    <div class="home-para-mi__cards">
      <article class="home-para-mi__card">
        <div class="home-para-mi__intro">
          <span class="home-para-mi__icon-box" aria-hidden="true">
            <img
              class="home-para-mi__icon"
              src="assets/img/Home/para-mi/icon-pn.svg"
              alt=""
            />
          </span>

          <div class="home-para-mi__text-block">
            <h3 class="home-para-mi__card-title">{{ content.natural.title }}</h3>
            <p class="home-para-mi__card-text">{{ content.natural.description }}</p>
          </div>
        </div>

        <ul class="home-para-mi__list">
          @for (paso of content.natural.pasos; track paso.idBanner ?? $index) {
            <li class="home-para-mi__list-item">
              <span class="home-para-mi__check" aria-hidden="true"></span>
              <span>{{ paso.descripcion }}</span>
            </li>
          }
        </ul>

        @if (isExternalUrl(content.natural.buttonUrl)) {
          <a
            class="home-para-mi__button"
            id="btn-home-hacer-crecer-negocio"
            [href]="content.natural.buttonUrl"
            target="_blank"
            rel="noopener noreferrer"
            (click)="trackParaMiCta('natural')"
          >
            {{ content.natural.buttonLabel }}
          </a>
        } @else if (fragmentOf(content.natural.buttonUrl); as fragment) {
          <a
            class="home-para-mi__button"
            id="btn-home-hacer-crecer-negocio"
            [routerLink]="[]"
            [fragment]="fragment"
            (click)="trackParaMiCta('natural')"
          >
            {{ content.natural.buttonLabel }}
          </a>
        } @else if (internalLinkOf(content.natural.buttonUrl); as link) {
          <a
            class="home-para-mi__button"
            id="btn-home-hacer-crecer-negocio"
            [routerLink]="routerCommandsOf(link)"
            [queryParams]="link.queryParams"
            [fragment]="link.fragment"
            (click)="trackParaMiCta('natural')"
          >
            {{ content.natural.buttonLabel }}
          </a>
        }
      </article>

      <article class="home-para-mi__card">
        <div class="home-para-mi__intro">
          <span class="home-para-mi__icon-box" aria-hidden="true">
            <img
              class="home-para-mi__icon"
              src="assets/img/Home/para-mi/icon-pj.svg"
              alt=""
            />
          </span>

          <div class="home-para-mi__text-block">
            <h3 class="home-para-mi__card-title">{{ content.juridica.title }}</h3>
            <p class="home-para-mi__card-text">{{ content.juridica.description }}</p>
          </div>
        </div>

        <ul class="home-para-mi__list">
          @for (paso of content.juridica.pasos; track paso.idBanner ?? $index) {
            <li class="home-para-mi__list-item">
              <span class="home-para-mi__check" aria-hidden="true"></span>
              <span>{{ paso.descripcion }}</span>
            </li>
          }
        </ul>

        @if (isExternalUrl(content.juridica.buttonUrl)) {
          <a
            class="home-para-mi__button"
            id="btn-home-potenciar-empresa"
            [href]="content.juridica.buttonUrl"
            target="_blank"
            rel="noopener noreferrer"
            (click)="trackParaMiCta('juridica')"
          >
            {{ content.juridica.buttonLabel }}
          </a>
        } @else if (fragmentOf(content.juridica.buttonUrl); as fragment) {
          <a
            class="home-para-mi__button"
            id="btn-home-potenciar-empresa"
            [routerLink]="[]"
            [fragment]="fragment"
            (click)="trackParaMiCta('juridica')"
          >
            {{ content.juridica.buttonLabel }}
          </a>
        } @else if (internalLinkOf(content.juridica.buttonUrl); as link) {
          <a
            class="home-para-mi__button"
            id="btn-home-potenciar-empresa"
            [routerLink]="routerCommandsOf(link)"
            [queryParams]="link.queryParams"
            [fragment]="link.fragment"
            (click)="trackParaMiCta('juridica')"
          >
            {{ content.juridica.buttonLabel }}
          </a>
        }
      </article>
    </div>
  </div>
</section>
